import { MapMarker } from '@app/core/model/entities/asset/map-marker';
import { AssetMapMarker } from '@app/shared/components/map/asset-map-marker';
import * as L from 'leaflet';
import { FeatureGroup } from 'leaflet';

export class AssetMapMarkerGroup {

  private clusterEnabled: boolean = true;
  private readonly markerClusterGroup: L.MarkerClusterGroup;
  private readonly featureGroup: FeatureGroup;

  constructor(public name: string,
                     markerClusterOptions: L.MarkerClusterGroupOptions,
                     public mapMarker?: MapMarker) {
    this.markerClusterGroup = new L.MarkerClusterGroup(markerClusterOptions);
    this.featureGroup = new FeatureGroup();
  }

  /**
   * Get the cluster group if the cluster mode is enabled, otherwise returns the feature group
   */
  public getFeatureGroup(): FeatureGroup {
    return this.clusterEnabled ? this.markerClusterGroup : this.featureGroup;
  }

  /**
   * Clear all layers in both layer group
   */
  public clearAllMarkers(): void {
    AssetMapMarkerGroup.clearFeatureGroup(this.markerClusterGroup);
    AssetMapMarkerGroup.clearFeatureGroup(this.featureGroup);
  }

  /**
   * Set the cluster mode
   * @param clusterEnabled if true the cluster group copy all the layers of the feature group and remove the feature group to the map
   * otherwise the feature group copy all the layers of the cluster group and remove the cluster group to the map
   */
  public setCluster(clusterEnabled: boolean): void {
    this.clusterEnabled = clusterEnabled;
    if (clusterEnabled && this.featureGroup.getLayers().length > 0) {
      AssetMapMarkerGroup.clearFeatureGroup(this.markerClusterGroup, false);
      this.markerClusterGroup.addLayers(this.featureGroup.getLayers());
      AssetMapMarkerGroup.clearFeatureGroup(this.featureGroup, false);
    } else if (!clusterEnabled && this.markerClusterGroup.getLayers().length > 0) {
      AssetMapMarkerGroup.clearFeatureGroup(this.featureGroup, false);
      this.markerClusterGroup.eachLayer((layer: AssetMapMarker) => {
        this.featureGroup.addLayer(layer);
      });
      AssetMapMarkerGroup.clearFeatureGroup(this.markerClusterGroup, false);
    }
  }

  /**
   * Unselect all the markers
   */
  public unSelectAllMarkers(): void {
    (this.getFeatureGroup().getLayers() as AssetMapMarker[]).forEach(marker => {
      marker.unSelect();
    });
  }

  /**
   * Select only markers with the same asset ID
   * @param assetId the asset's ID
   */
  public selectMarker(assetId: string): void {
    (this.getFeatureGroup().getLayers() as AssetMapMarker[]).forEach(marker => {
        if (assetId === marker.assetId) {
          marker.select();
        } else {
          marker.unSelect();
        }
      }
    );
  }

  /**
   * Remove a feature group to the map the clear all his layers
   * @param featureGroup the feature group to clear
   * @param clearEventsListeners if true clear all the events listeners of the feature group and his layers
   */
  private static clearFeatureGroup(featureGroup: FeatureGroup, clearEventsListeners: boolean = true): void {
    featureGroup.remove();
    if (clearEventsListeners) {
      featureGroup.eachLayer((layer => layer.clearAllEventListeners()));
      featureGroup.clearAllEventListeners();
    }
    featureGroup.clearLayers();
    featureGroup.eachLayer((layer => featureGroup.removeLayer(layer)));
  }

}
